import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.primary,
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.25, 1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
  toolbarLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  toolbarChip: {
    fontSize: '0.7rem',
    height: 24,
    cursor: 'pointer',
  },
  toolbarChipActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  toolbarDivider: {
    height: 16,
    width: 1,
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(0, 0.5),
  },
  toolbarSummary: {
    marginLeft: 'auto',
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  empty: {
    padding: theme.spacing(3),
    textAlign: 'center',
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}))

export default useStyles
